<template>
  <div class="parent-box">
    <div class="content">
      <van-list
        v-model:loading="state.loading"
        :finished="state.finished"
        finished-text="没有更多了"
        @load="onLoad"
      >
        <van-cell
          v-for="(item, i) in state.getLists"
          :key="i + '-list'"
          :border="false"
        >
          <template #value>
            <p>领取 {{ item.money }}余额（赠送）</p>
            <p>
              领取时间：<span>{{ time(item.add_time) }}</span>
            </p>
          </template>
        </van-cell>
      </van-list>
    </div>
  </div>
</template>
<script>
import { useRouter } from "vue-router";
import { reactive, onMounted, computed, onActivated } from "vue";
import { useStore } from "vuex";
import { getSavingCardAwardRecord } from "@/api/yzuser.js";
import { dateYMDHM } from "@/utils/date.js";
import { Toast } from "vant";
import { setToken, getToken, removeToken } from "@/utils/auth";
import { getQueryString } from "../../../utils/location";
export default {
  name: "get_record",
  setup() {
    const router = useRouter();
    const store = useStore();
    const state = reactive({
      getLists: [],
      loading: false,
      finished: false,
    });
    onActivated(() => {
      if (getQueryString("token")) {
        setToken(getQueryString("token"));
      }
      // onLoad();
    });

    // 对时间戳进行处理
    const time = computed(() => {
      return function(date) {
        return dateYMDHM(date);
      };
    });

    var pagecode = 1;
    var totalpage = 1;
    const onLoad = () => {
      getSavingCardAwardRecord({
        username: getQueryString("username"),
        pagecode: pagecode,
      }).then((res) => {
        console.log("赠送余额领取记录", res.data.data);
        if (pagecode == 1) {
          state.getLists = [];
        }
        if (res.data.code == 1) {
          totalpage = res.data.data.total_page;
          if (pagecode > res.data.data.total_page) {
            state.finished = true;
            return;
          }

          state.getLists = state.getLists.concat(res.data.data.lists);
        } else {
          Toast(res.data.msg);
          state.finished = true;
        }
        // console.log(pagecode)
        pagecode++;
        state.loading = false;
        // console.log("赠送余额领取记录----------", state.getLists);
      });
    };

    return {
      state,
      onLoad,
      time,
    };
  },
};
</script>
<style scoped="scoped" src="../../../styles/van-sticky-nav.css"></style>
<style scoped="scoped">
.parent-box {
  padding-top: 30px;
  height: 100vh;
  overflow: auto;
  background-color: #f7f8fa;
  padding-left: 32px;
  padding-right: 32px;
  padding-bottom: 50px;
}

.van-cell {
  width: 686px;
  height: 134px;
  background: #fff;
  display: block;
  border-radius: 16px;
  padding: 24px;
  margin-bottom: 20px;
}
.van-cell p {
  color: #333;
}
.van-cell p:nth-of-type(1) {
  font-size: 32px;
  color: #333;
  font-weight: bold;
  /* margin-bottom: 12px; */
}
.van-cell p:nth-of-type(2) {
  /* margin-top: 12px; */
  font-size: 24px;
}
</style>
